import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/lib/ui/utils';

/**
 * Points chip — the "+N pts" / "Up to N pts" pill shared across the rewards
 * surface (quests, earn cards, milestones).
 *
 * Mirrors the account pill (`ACCOUNT_PILL_CLASS`): a brand-tinted capsule with a
 * brand border and brand-tinted text. All three tokens are mode-aware, so dark
 * mode reads as a deep-navy chip with a light-blue border and text.
 */
export function PointsChip(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex shrink-0 items-center whitespace-nowrap rounded-pill px-2 py-0.5 text-caption font-medium", "bg-background-brand text-foreground-brand border border-border-brand", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <span className={t1}>{children}</span>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}